<template>
  <div class="main">
    <BaseHeader/>
    <router-view class="router_view"></router-view>
    <BaseFooter/>
  </div>
</template>

<script>
// @ is an alias to /src
import BaseHeader from '@/components/base/BaseHeader.vue'
import BaseFooter from '@/components/base/BaseFooter.vue'

export default {
  // name: 'main',
  components: {
    'BaseHeader': BaseHeader,
    'BaseFooter': BaseFooter
  }
}
</script>
<style>
  .router_view{
    min-height: calc(100vh - 162px);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
</style>
